
import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import {symbols} from '../data/symbols'
import * as coreUtilsLib from 'santa-core-utils'

export class Symbol extends React.Component {
    shouldComponentUpdate(nextProps) {
        return nextProps.name !== this.props.name ||
            nextProps.className !== this.props.className ||
            !_.isEqual(this.props.style, nextProps.style) ||
            nextProps.hintId !== this.props.hintId
    }

    getSvgDef() {
        const ret = symbols[this.props.name]
        if (!ret) {
            coreUtilsLib.log.error('SVG symbol %s does not exist', this.props.name)
        }
        if (ret && this.props.customDimensions) {
            _.merge(ret.svg, this.props.customDimensions)
        }
        if (_.get(ret, 'svg.class')) {
            ret.svg = _(ret.svg)
                .assign({className: ret.svg.class})
                .omit('class')
                .value()
        }
        return ret || {content: '', svg: {}}
    }

    // TODO: Move this into a mixin & search for all occurrences
    getClassName(defaultClassName) {
        return (defaultClassName ? defaultClassName : '') + (this.props.className ? ` ${this.props.className}` : '')
    }

    clickHandler(e) {
        if (this.props.onClick) {
            this.props.onClick(e)
        }
    }

    render() {
        const def = this.getSvgDef()
        const markup = {__html: def.content}
        const className = _.trim(`${def.svg.className || ''} ${this.getClassName(`symbol symbol-${this.props.name}`)}`)
        const style = _.assign(def.svg.style, this.props.style)
        const props = _.omit(def.svg, ['className', 'style'])
        return <svg {...props} className={className} style={style} onClick={this.clickHandler.bind(this)} dangerouslySetInnerHTML={markup}></svg> //eslint-disable-line react/self-closing-comp,react/no-danger
    }
}

Symbol.displayName = 'Symbol'
Symbol.propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
    customDimensions: PropTypes.object,
    hintId: PropTypes.string
}
